import script from "./topCenterAlarm.vue?vue&type=script&setup=true&lang=js"
export * from "./topCenterAlarm.vue?vue&type=script&setup=true&lang=js"

import "./topCenterAlarm.vue?vue&type=style&index=0&id=453ddcc7&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453ddcc7"]])

export default __exports__